const bytesFmt = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 1 });

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${bytesFmt.format(value)} ${units[unit]}`;
}

const dateTimeFmt = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', timeStyle: 'short' });

/** Acepta Timestamp de Firestore (toDate) o Date. */
export function formatDateTime(value: unknown): string {
  if (!value) return '—';
  const date =
    value instanceof Date
      ? value
      : typeof value === 'object' && 'toDate' in value && typeof value.toDate === 'function'
        ? (value.toDate() as Date)
        : null;
  return date ? dateTimeFmt.format(date) : '—';
}

export function formatDuration(ms: number | null | undefined): string {
  if (!ms) return '';
  const total = Math.round(ms / 1000);
  const m = Math.floor(total / 60);
  const s = String(total % 60).padStart(2, '0');
  return `${m}:${s}`;
}

/** Mensaje de un HttpsError de una Function; el SDK le agrega el código HTTP al final (" [404]"). */
export function callableMessage(error: unknown): string {
  return typeof error === 'object' &&
    error &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message
    ? error.message.replace(/\s*\[\d{3}\]$/, '')
    : 'Algo salió mal. Inténtalo de nuevo.';
}
